import { render } from "./VvStoredObjectInput.vue?vue&type=template&id=a45761ce"
import script from "./VvStoredObjectInput.vue?vue&type=script&lang=js"
export * from "./VvStoredObjectInput.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__